import React from 'react'
import { useMutation } from '@apollo/client'
import { useSnackbar } from 'notistack'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import Box from '@material-ui/core/Box'
import Divider from '@material-ui/core/Divider'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import StepDescription from '../step-description'
import { RedeemLessonCreditQuery } from './query'
import { useStyles } from './styles'
import { gtmEvent } from 'lib/gtm'
import ArrowBackOutlinedIcon from '@material-ui/icons/ArrowBackOutlined'
import CoachCardSm from 'components/coach-card-small'
import BookingTypeCard from './booking-type-card'
import StudentCard from './student-card'
import StepDescriptionMobile from '../step-description-mobile'

const LessonReviewLayout = ({
  lessonType,
  locationId,
  startDateTime,
  student,
  previousUrl,
  setIsComplete,
  lessonCreditBalanceQuantity,
}) => {
  const { title, category, durationInMinutes, coach, facilities } = lessonType
  const facility = facilities.find(({ id }) => id === locationId)
  const profilePhoto = coach?.coachProfile?.profilePhoto
  const studentName = `${student.firstName} ${student.lastName}`

  const { enqueueSnackbar } = useSnackbar()
  const [redeemLesson, { loading }] = useMutation(RedeemLessonCreditQuery)

  const onSubmit = async () => {
    return redeemLesson({
      variables: {
        studentId: student.id,
        lessonTypeId: lessonType.id,
        startDateTime,
        locationId: facility.id,
      },
    })
      .then(({ data }) => {
        const { success, message } = data.redeemLessonCredit

        if (success) {
          enqueueSnackbar(message, {
            variant: 'success',
          })
          gtmEvent({
            event: 'formSubmit',
            formCategory: 'redeem-lesson',
            formAction: 'clicked-book-session-only-button',
          })

          setIsComplete(true)
        } else {
          enqueueSnackbar(message, {
            variant: 'error',
          })
        }
      })
      .catch(error => {
        window.rg4js &&
          window.rg4js('send', {
            error: error,
            tags: ['bookings', 'form-submit'],
          })
        enqueueSnackbar('An error has occurred. Please try again later.', {
          variant: 'error',
        })
      })
  }

  const classes = useStyles()

  if (loading) {
    return (
      <Container className={classes.root}>
        <div className={classes.loadingStyles}>
          <CircularProgress color="primary" />
        </div>
      </Container>
    )
  }

  return (
    <Container className={classes.root}>
      <Grid container>
        <Grid item xs={12}>
          <Box flexGrow={1} display={{ xs: 'none', md: 'flex' }}>
            <Button href={previousUrl} startIcon={<ArrowBackOutlinedIcon />}>
              BACK
            </Button>
          </Box>
        </Grid>
        <Grid item md={7} xs={12}>
          <StepDescriptionMobile
            stepText="Step 3 of 3"
            previousUrl={previousUrl}
          />
          <StepDescription
            stepText="Step 3 of 3"
            title="Review"
            description="Please review the information below."
          />
          <CoachCardSm
            coach={{
              name: coach?.name,
              coachAvatar: profilePhoto,
              facilityName: facility.name,
            }}
          />
          <BookingTypeCard
            category={category}
            facility={facility}
            title={title}
            startDateTime={startDateTime}
            durationInMinutes={durationInMinutes}
            lessonCreditBalanceQuantity={lessonCreditBalanceQuantity}
          />
          <StudentCard student={student} studentName={studentName} />
          <Divider className={classes.dividerStyles} />
          <Grid item md={5} xs={12}>
            <Box mb={4} textAlign="left">
              <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={onSubmit}
                fullWidth
              >
                BOOK SESSION
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  )
}

export default LessonReviewLayout
